<template>
    <div class="modal" id="pg-product-services-type-modal" tabindex="-1" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Add Product/Services</h5>
                    <button type="button" class="close" @click="close" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <button class="form-control btn btn-secondary-custom p-10" @click="openPGProductServicesModal();close()">Product or Service</button>
                    <button class="form-control btn btn-secondary-custom mt-3 p-10" @click="openPGBundleModal();close()">Bundle</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'pg-product-services-type-modal',
    methods: {
        open() {
            $('#pg-product-services-type-modal').modal('show');
        },
        close() {
            $('#pg-product-services-type-modal').modal('hide');
        },
        openPGProductServicesModal() {
            Bus.$emit('open-pg-product-services-modal');
        },
        openPGBundleModal() {
            Bus.$emit('open-pg-bundle-modal');
        }
    }
}
</script>

<style scoped>
.btn-secondary-custom,
.btn-secondary-custom:hover {
    color: black;
    background-color: #ebebeb;
    border-color: #dedcdc;
    line-height: 0;
    border-radius: 5px;
}
</style>
